/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type RouteConnectionModeEnum =
  (typeof RouteConnectionModeEnum)[keyof typeof RouteConnectionModeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RouteConnectionModeEnum = {
  Walk: 0,
  Transit: 1,
  Unresolved: 2,
} as const;
